import React from "react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import { fetchData } from "../../store/actions/handelData";
import { useEffect } from "react";
import "fix-date";
import { DataTranform } from "../../functions/DateTranform";
import { CeckConnection } from "../../functions/ConnectionStatius";
import Swal from "sweetalert2";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Tooltip } from "@mui/material";

function DataPikers({ fetchFunctions }) {
  const dispatch = useDispatch();

  const [startDate, setStartDate] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [daySelected, setDaySelected] = useState(DataTranform(startDate));

  useEffect(() => {
    // daySelected è già formattato correttamente (senza zeri) grazie a DataTranform
    dispatch(fetchData(daySelected));
    dispatch(fetchFunctions(daySelected, 30));
  }, [dispatch, fetchFunctions, daySelected]);

  // gestisce la parte in cui è stata gia selezionata la data
  // Solo aggiorniamo state: l'unico fetch è fatto dall'useEffect (evita doppia chiamata e race)
  const handleDateSelect = (date) => {
    if (!CeckConnection()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sembra che la tua connessione sia assente o instabile",
      });
      return;
    }
    setStartDate(date);
    setDaySelected(DataTranform(date));
    setIsOpen(false);
  };

  // mostra il caledario da cui scegliere la data
  const rederDatePikers = (e) => {
    if (!CeckConnection()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Sembra che la tua connessione sia assente o instabile",
      });
      return;
    }
    //-----
    e.preventDefault();
    setIsOpen(true);
  };

  return (
    <div className="data-pikers">
      {isOpen ? (
        <DatePicker
          className="data-pikers-date"
          locale="it"
          selected={startDate}
          value={startDate}
          onChange={(date) => handleDateSelect(date)}
          dateFormat="dd-MM-yyyy"
          calendarClassName="data-calendar"
          inline
        />
      ) : (
        <Tooltip title="Seleziona data" placement="top" arrow>
          <button className="btn-date" onClick={rederDatePikers}>
            {startDate.toLocaleDateString()}
            <CalendarMonthIcon className="icon-calendar" />
          </button>
        </Tooltip>
      )}
    </div>
  );
}

export default DataPikers;
